import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Category } from "../../../common/models/support/Category";
import { Observable } from "rxjs";
import { ResponseModel } from "src/app/common/models/ResponseModel";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root'
})
export class SearchApiService {
  private apiDomain = environment.FT_HELP_URL_API;

  constructor(private http: HttpClient) { }

  /**
   * Retrieves categories based on the provided version.
   *
   * @param version - the version of the categories to retrieve
   * @returns An Observable<Category[]> representing the categories.
   */
   public getCategories(): Observable<Category[]> {
    const url = `${this.apiDomain}/articles/categories?version=V10&lang=no`;
    return this.http.get<ResponseModel<Category[]>>(url).pipe(
      map(res => res.data)
    );
  }
}

